import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderHelpers";
import { BuilderState } from "@builder/store/slices/BuilderSlice/types";
import { SimpleCartNode } from "@common/build/types";
import { PayloadAction } from "@reduxjs/toolkit";

export const updateSimpleCartShowTaxes = (state: BuilderState, action: PayloadAction<boolean>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.showTaxes = action.payload;
    }
};

export const updateSimpleCartMode = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]["mode"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.mode = action.payload;
    }
};

export const updateSimpleCartExpandedNode = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode = action.payload;
    }
};

export const updateSimpleCartExpandedMainBg = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]["mainBg"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.mainBg = action.payload;
    }
};

export const updateSimpleCartExpandedTotalBg = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]["totalBg"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.totalBg = action.payload;
    }
};

export const updateSimpleCartExpandedDividerColor = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]["dividerColor"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.dividerColor = action.payload;
    }
};

export const updateSimpleCartExpandedWidth = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]["cartWidth"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.cartWidth = action.payload;
    }
};

export const updateSimpleCartExpandedName = (state: BuilderState, action: PayloadAction<SimpleCartNode["expandedNode"]["cartName"]>) => {
    const scNode = getSelectedNode(state) as SimpleCartNode;
    if (scNode && scNode.type == "simpleCart") {
        scNode.expandedNode.name = action.payload;
    }
};
